import { Button, Stack } from '@mui/material'
import { useTranslation } from 'react-i18next'

import ToolStateDropdown from './ToolStateDropdown'
import { useAppDispatch, useAppSelector } from 'redux/Hook'
import { saveTool, updateTool } from 'redux/thunks/ToolBuilder'
import { createPinnedItem } from 'redux/thunks/PinnedItems'
import { useToolBuilder } from 'containers/ToolBuilder/Hook'

export interface FormRefHandle {
  isValid: () => { isValid: boolean; data: any | null }
}

interface ActionButtonsProps {
  formRef: React.RefObject<FormRefHandle>
}

function ActionButtons({ formRef }: ActionButtonsProps) {
  const dispatch = useAppDispatch()
  const { t } = useTranslation()
  const { toolType, addToolIdToQueryParams } = useToolBuilder()

  const {
    toolBuilder: { id, permaLink },
    saving,
    fetching,
  } = useAppSelector((state) => state.toolBuilder)

  const { pinnedItems } = useAppSelector((state) => state.pinnedItems)

  const handleSave = async () => {
    const validForm = await formRef?.current?.isValid()
    if (!validForm) return

    const pinnedItemExists = Object.values(pinnedItems).some(
      (item: any) => item.attributes['pinnable-type'] === toolType,
    )

    if (id) {
      await dispatch(updateTool())
      addToolIdToQueryParams(permaLink)

      return
    }

    await dispatch(saveTool())
    addToolIdToQueryParams(permaLink)

    if (!pinnedItemExists) {
      await dispatch(
        createPinnedItem({ name: t(`toolBuilder.tools.${toolType}`) }),
      )
    }
  }

  return (
    <Stack
      spacing={2}
      direction="row"
      alignItems="center"
      justifyContent={{ xs: 'space-between', md: 'flex-end' }}
    >
      <ToolStateDropdown />
      <Button
        variant="contained"
        color="primary"
        onClick={handleSave}
        disabled={fetching || saving}
      >
        {t('common.save')}
      </Button>
    </Stack>
  )
}

export default ActionButtons
